<template>
    <div>
        <v-tooltip location="top" :disabled="!showTooltip">
            <template v-slot:activator="{ props }">
                <v-btn
                    :color="colorPicker"
                    :class="{ 'darken-3': active, selected: selected }"
                    :variant="!hasCondition ? 'outlined' : undefined"
                    theme="dark"
                    size="small"
                    @click="touchTapHandler($event)"
                    v-bind="props"
                >
                    {{ wellData.isBlank ? null : wellData.id }}
                </v-btn>
            </template>
            <div>
                <div v-if="wellData.condition && wellData.condition.samp">
                    <b>{{ wellData.condition.samp }}</b>
                </div>
                <div v-if="wellData.condition">
                    <b>{{ conditionNameString || batchNameString }}</b> ({{
                        conditionSourceTypeString
                    }})
                </div>
                <div v-if="sampleTypeString">Sample Type: {{ sampleTypeString }}</div>
                <div v-if="controlTypeString">Control Type: {{ controlTypeString }}</div>
                <div v-if="sampleDescriptorString">
                    Sample Descriptor: {{ sampleDescriptorString }}
                </div>
                <div v-if="entityKeyString">Entity Key: {{ entityKeyString }}</div>
                <div v-if="subwell">
                    <div v-for="(value, key, i) in subwell" :key="i">{{ key }}: {{ value }}</div>
                </div>
                <div v-if="experimentCodeString">Experiment Code: {{ experimentCodeString }}</div>
                <div v-if="collectionDate">Collection Date: {{ collectionDate }}</div>
                <div v-if="note">Note: {{ note }}</div>
            </div>
        </v-tooltip>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
    name: "WellInfo",

    props: {
        batchMap: Map,
        col: {
            type: Number,
        },
        row: {
            default: 0,
            type: Number,
        },
    },

    data: () => {
        return {
            active: false,
        };
    },

    computed: {
        ...mapGetters("plateCreate", [
            "hasActiveCondition",
            "activeCondition",
            "layout",
            "protocols",
            "sampleDescriptors",
            "sampleTypes",
            "entityKeys",
            "plateWellSelection",
            "editedWellsArray",
        ]),
        wellData: function () {
            return this.layout[this.row][this.col];
        },
        hasCondition: function () {
            return !!this.wellData.condition;
        },
        selected: function () {
            return this.plateWellSelection.includes(this.wellData.id);
        },
        sampleDescriptorString: function () {
            const sampleDescriptor = this.wellData.sampleDescriptor;
            return sampleDescriptor ? sampleDescriptor.name : "";
        },
        entityKeyString: function () {
            const entityKey = this.wellData.entityKey;
            return entityKey && entityKey.length > 0
                ? entityKey.map((key) => key.name).join(", ")
                : "";
        },
        colorPicker: function () {
            if (this.isControl) {
                return "grey lighten-1";
            } else if (this.existing && !this.edited) {
                return "green";
            } else if (this.edited) {
                return "red";
            } else if (this.wellData.condition) {
                return "orange";
            } else {
                return "grey lighten-1";
            }
        },
        edited: function () {
            return this.editedWellsArray.includes(this.wellData.id);
        },
        sampleTypeString: function () {
            return _.get(this.wellData, "sampleType.name");
        },
        experimentCodeString: function () {
            return _.get(this.wellData, "condition.experiment_code");
        },
        conditionNameString: function () {
            return _.get(this.wellData, "condition.name");
        },
        note: function () {
            return _.get(this.wellData, "note");
        },
        subwell: function () {
            return _.get(this.wellData, "subwell");
        },
        conditionSourceTypeString: function () {
            return _.get(this.wellData, "condition.type");
        },
        controlTypeString: function () {
            return (
                _.get(this.wellData, "condition.control_type") ||
                _.get(this.wellData, "condition.condition_type")
            );
        },
        collectionDate: function () {
            return _.get(this.wellData, "collectionDate");
        },
        batchNameString: function () {
            return _.get(this.wellData, "condition.batch_name");
        },
        showTooltip: function () {
            return !!this.wellData.condition;
        },
        existing: function () {
            return !!this.wellData.sampleId;
        },
        isControl: function () {
            return _.get(this.wellData, "sampleType.name") === "control";
        },
    },

    methods: {
        ...mapActions("plateCreate", [
            "assignConditionToDestinationWell",
            "removeConditionFromDestinationWell",
            "togglePlateSelection",
        ]),
        async touchTapHandler($event) {
            console.log("WELLDATA", this.wellData);
            this.togglePlateSelection(this.wellData.id);
        },
    },
});
</script>

<style scoped>
.existing {
    border: 2px solid darkgreen !important;
}
.selected {
    border: 5px solid yellow !important;
}
.darken-3.selected {
    border: 5px solid yellow !important;
}
#what:hover {
    fill: blue;
}
</style>
